import * as React from 'react';
import { connect } from 'react-redux';
import { cn, Label, Tile, Flex, withPadding, Box, Button, Text, Link, Icon } from 'sg-styleguide';

import './theme.scss';
import {
	FlexWithPadding,
	TextWithPadding,
	BoxWithPadding
} from '../../components/helpers'

import LoaderWrapper from '../../components/helpers/loader-wrapper';
import Iframe from '../../components/iframe'
import Builders from '../../components/builders'

import {
	AddTheme,
	StepChangeNext,
	AddPlugin,
	RemovePlugin,
	RemoveAllPlugins,
	PreviewTheme
} from '../../actions/actions';

class Theme extends React.Component{

	constructor(props) {
		super(props);

		this.state = {
			showIframe: false,
			showBuilders: false
		}

		this.classes = cn(
			this.props.className,
			'themes--preview',
			( this.props.is_default && !this.props.selectedTheme || (this.props.selectedTheme === this.props.id) ) ? 'themes--preview-current' : '',
		);

		if ( this.props.is_default && !this.props.selectedTheme ) {
			this.props.addTheme( this.props.id );
		}
	}

	addBuilders( ) {
		this.props.themeBuilders.map( plugin => {
			if ( _.includes( this.props.selectedPlugins, plugin.id ) ) {
				this.props.addPlugin( plugin.id );
			}
		})
	}

	addRecommendedPlugins() {
		this.props.recommendedPlugins.map( plugin => {
			this.props.addPlugin( plugin.id );
		} )
	}

	removeThemeBuilders() {
		this.props.themeBuilders.map( plugin => {
			this.props.removePlugin( plugin.id );
		})
	}

	toggleIframe = () => {
		this.setState({
			showIframe: ! this.state.showIframe
		});
	}

	toggleBuilders = () => {
		( this.state.showBuilders ) ? this.removeThemeBuilders() : false;

		this.setState({
			showBuilders: ! this.state.showBuilders
		});
	}

	addTheme = (id) => {
		// Remove all plugins.
		this.props.removeAllPlugins();
		// Add theme builders.
		this.addBuilders();
		// Add all recommened plugins when the theme is changed.
		this.addRecommendedPlugins();
		// Add the theme to store.
		this.props.addTheme( this.props.previewedTheme.id );
		// Go to next step.
		this.props.changeStepNext();
	}

	getButtonText() {
		if ( this.props.selectedTheme !== this.props.id ) {
			return window.wizardData.strings.select
		}

		return ( this.props.is_default ) ? window.wizardData.strings.default : window.wizardData.strings.currently_selected;
	}

	render() {
        const isPhone = this.props.Environment && this.props.Environment.isPhone;
        return (
			<BoxWithPadding
				sm="6"
				padding={isPhone? ['none', 'x-small', 'xx-small', 'x-small'] : ['none', 'small', 'large', 'small']}
			>
				{ this.state.showBuilders &&	
				<Builders
					builders={this.props.themeBuilders}
					onClose={this.toggleBuilders}
					onConfirm={this.addTheme}
					removePlugin={this.props.removePlugin}
					addPlugin={this.props.addPlugin}
				/>
				}

				<Tile padding="none" >
					<Link
						className={this.classes}
						onMouseEnter={ e => this.props.previewTheme( this.props.id ) }
						onClick={this.toggleIframe.bind(this)}
					>
						<Icon
							className="themes--preview-icon"
							color="white"
							name="zoom-in"
							size="40"
						/>
						<img src={this.props.thumbnail} />
					</Link>

					<FlexWithPadding
						className="ua-border-top themes--footer"
						margin="none"
						padding={['small']}
						gutter="small"
						align="center"
						justify="space-between"
						wrap="nowrap"
					>
						<TextWithPadding
							weight="regular"
							padding={['x-small','none']}
							style={{textAlign:'left'}}
						>
							{this.props.name}

							<span className="themes--footer-price">
								({ ( this.props.free ) ? window.wizardData.strings.free : this.props.price.currency_code + this.props.price.price })
							</span>

						</TextWithPadding>

						<Button
							color="primary"
							disabled={this.props.selectedTheme === this.props.id ? true : false }
							onMouseEnter={ e => this.props.previewTheme( this.props.id ) }
							onClick={ e => this.props.previewedTheme.builders ? this.toggleBuilders() : this.addTheme() }
						>
							{this.getButtonText()}
						</Button>

					</FlexWithPadding>
				</Tile>
				{this.state.showIframe &&
					<Iframe
						themes={this.props.themes}
						isLoaded={this.props.isLoaded}
						loaded={this.props.loaded}
						loading={this.props.loading}
						onClose={this.toggleIframe}
						changeStepNext={this.props.changeStepNext}
						onGet={this.props.previewedTheme.builders ? this.toggleBuilders : this.addTheme }
						selectedTheme={this.props.selectedTheme}
						previewedTheme={this.props.previewedTheme}
						previewTheme={this.props.previewTheme}
						isPhone={this.props.isPhone}
					/>

				}
			</BoxWithPadding>
		);
	}
};

const mapStateToProps = state => {
	var previewedTheme = _.find( state.dataReducer.themes, { id: state.userChoiceReducer.previewTheme });

	if ( previewedTheme && previewedTheme.builders ) {
		var themeBuilders =  _.intersectionBy(state.dataReducer.plugins, JSON.parse( previewedTheme.builders ), 'id');
	}

	return {
        Environment: state.Environment,
		plugins: state.dataReducer.plugins,
		selectedTheme: state.userChoiceReducer.selectedTheme,
		selectedPlugins: state.userChoiceReducer.selectedPlugins,
		recommendedPlugins: state.dataReducer.recommendedPlugins,
		previewedTheme: previewedTheme,
		themeBuilders: themeBuilders ? themeBuilders : [],
		isPhone: state.Environment.isPhone
	};
};

const mapDispatchToProps = dispatch => {
	return {
		addTheme: (id) => dispatch(AddTheme(id)),
		addPlugin: (id) => dispatch(AddPlugin(id)),
		removePlugin: (id) => dispatch(RemovePlugin(id)),
		previewTheme: (id) => dispatch(PreviewTheme(id)),
		changeStepNext: () => dispatch(StepChangeNext()),
		removeAllPlugins: () => dispatch(RemoveAllPlugins()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(
	LoaderWrapper( Theme )
);
